import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CustomSelect from "../shared/custom-components/select";
import Search from "../shared/custom-components/search";
import { cleanIputText } from "./functions";

const FilterComponent = ({
  filter,
  searchFnc,
  pageSize,
  pageSizeItems,
  handlePageSizeSelection,
}) => {
  const [{ selectedValue, searchValue }, setState] = useState({
    selectedValue: filter[0].property,
    searchValue: "",
  });

  const { t } = useTranslation();

  const handleChange = ({ property }) =>
    setState((prev) => ({ ...prev, selectedValue: property }));

  const searchChange = ({ target }) => {
    if (target.value == "") searchFnc(0, "");
    setState((prev) => ({
      ...prev,
      searchValue: cleanIputText(target.type, target.value),
    }));
  };

  const handleKey = (event) => {
    if (event.key == "Enter") search();
  };

  const search = () => {
    if (selectedValue != "" && searchValue != "")
      searchFnc(selectedValue, searchValue);
  };

  const pageSizeSelection = (event) => {
    handlePageSizeSelection(event.value);
  };

  useEffect(() => {
    setState((prev) => ({ ...prev, selectedValue: filter[0].property }));
  }, [filter]);

  return (
    <div className="filter-bar">
      {pageSizeItems && (
        <div className="page-size-selection">
          <p className="page-size-selection-title">{t("general.filters.pageSize")}</p>
          <CustomSelect
            id="page-size-select"
            className={`page-size`}
            placeholder={pageSize}
            items={pageSizeItems}
            handleChange={pageSizeSelection}
          />
        </div>
      )}
      <div className="filter">
        <CustomSelect
          id="filtersBar"
          className={`filter-search`}
          placeholder={t("general.filters.placeholder")}
          items={filter}
          handleChange={handleChange}
        />
      </div>
      <Search
        id="search-field"
        name="searchValue"
        placeholder={t("general.filters.search")}
        className="Input__input Search__input"
        onChange={searchChange}
        onSearchClick={search}
        onKeyDown={handleKey}
        value={searchValue}
      />
    </div>
  );
};

export default FilterComponent;
